import { SortByOptionsValueEnum } from "@/enums/sortByOptionsValueEnum";
import { Option } from "../interfaces/Option";

export const PICKUP_DELIVERY_OPTIONS: Option[] = [
  { value: null, text: "" },
  { value: true, text: "Pickup" },
  { value: false, text: "Delivery" },
];

export const ORDER_HISTORY_SORT_OPTIONS: Option[] = [
  { value: SortByOptionsValueEnum.INVOICE_DATE_ASC, text: "Invoice Date Asc" },
  { value: SortByOptionsValueEnum.INVOICE_DATE_DESC, text: "Invoice Date Desc" },
  { value: SortByOptionsValueEnum.ORDER_DATE_ASC, text: "Order Date Asc" },
  { value: SortByOptionsValueEnum.ORDER_DATE_DESC, text: "Order Date Desc" },
];
